import { render, staticRenderFns } from "./activity-2.vue?vue&type=template&id=5231029e&"
import script from "./activity-2.vue?vue&type=script&lang=js&"
export * from "./activity-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports